export default __webpack_public_path__ + "images/2a3382595674f0b92ef409b22f0854f1-logo_erc-flag_eum.png";